import {
  Box,
  Typography,
  Divider,
  Button,
  TextField,
  InputAdornment,
  ToggleButtonGroup,
  ToggleButton,
  FormControlLabel,
  Switch,
} from "@mui/material";
import {
  LocalOffer as DiscountIcon,
  Receipt as ReceiptIcon,
  LocalShipping as ShippingIcon,
} from "@mui/icons-material";

export default function TotalsFooter({
  subtotal,
  discount, // giá trị người nhập
  discountType, // "amount" | "percent"
  discountValue, // số tiền đã trừ (tính ở parent)
  finalTotal, // tổng sau giảm (parent phải tính lại theo shippingEnabled)
  setDiscount,
  setDiscountType,
  shippingEnabled,
  setShippingEnabled,
  onCheckout,
  canCheckout,
}) {
  // --- xử lý input ---
  const handleDiscountChange = (e) => {
    const raw = e.target.value;
    const num = Number(String(raw).replace(/[^\d.]/g, ""));
    if (Number.isNaN(num)) return;

    if (discountType === "percent") {
      const clamped = Math.max(0, Math.min(100, num));
      setDiscount(clamped);
    } else {
      const clamped = Math.max(0, Math.min(subtotal, num));
      setDiscount(clamped);
    }
  };

  // --- xử lý đổi loại giảm giá ---
  const handleTypeChange = (_e, next) => {
    if (!next) return;
    if (next === "percent") {
      const percent =
        subtotal > 0
          ? Math.min(100, Math.max(0, (discount / Math.max(1, subtotal)) * 100))
          : 0;
      setDiscount(Number(percent.toFixed(2)));
    } else {
      const amount = Math.max(
        0,
        Math.min(subtotal, Math.round((discount / 100) * subtotal))
      );
      setDiscount(amount);
    }
    setDiscountType(next);
  };

  return (
    <Box
      sx={{
        borderTop: "1px solid #eee",
        pt: 2,
        bgcolor: "#fff",
        zIndex: 1300,
        p: 2,
        width: "100%",
        position: { xs: "fixed", sm: "sticky" },
        bottom: 0,
        left: 0,
        right: 0,
        pb: { xs: `calc(16px + env(safe-area-inset-bottom))`, sm: 2 },
      }}
    >
      {/* Tổng tiền hàng */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          mb: 1,
          flexDirection: { xs: "column", sm: "row" },
          alignItems: { xs: "flex-start", sm: "center" },
        }}
      >
        <Typography variant="body1">Tổng tiền hàng</Typography>
        <Typography
          variant="body1"
          fontWeight="bold"
          sx={{ mt: { xs: 0.5, sm: 0 } }}
        >
          {subtotal.toLocaleString("vi-VN")}₫
        </Typography>
      </Box>

      {/* Giảm giá */}
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: "space-between",
          mb: 1,
        }}
      >
        <Typography
          variant="body1"
          sx={{ mb: { xs: 0.5, sm: 0 }, flexShrink: 0 }}
        >
          Giảm giá
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            gap: 1,
            width: { xs: "100%", sm: "auto" },
            alignItems: { xs: "flex-start", sm: "center" },
          }}
        >
          <TextField
            value={discount}
            onChange={handleDiscountChange}
            type="number"
            size="small"
            disabled={subtotal <= 0}
            inputProps={{
              min: 0,
              step: discountType === "percent" ? "0.1" : "1000",
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <DiscountIcon fontSize="small" />
                </InputAdornment>
              ),
            }}
            sx={{ width: { xs: "100%", sm: 160 } }}
            placeholder={discountType === "percent" ? "Nhập %" : "Nhập số tiền"}
          />

          <ToggleButtonGroup
            value={discountType}
            exclusive
            onChange={handleTypeChange}
            size="small"
          >
            <ToggleButton value="amount">₫</ToggleButton>
            <ToggleButton value="percent">%</ToggleButton>
          </ToggleButtonGroup>

          <Typography
            color="error"
            sx={{
              minWidth: { xs: "100%", sm: 120 },
              textAlign: { xs: "left", sm: "right" },
            }}
          >
            -{discountValue.toLocaleString("vi-VN")}₫
            {discountType === "percent" && subtotal > 0
              ? ` (${discount}%)`
              : ""}
          </Typography>
        </Box>
      </Box>

      {/* Switch phí ship */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 1,
        }}
      >
        <Typography variant="body1">Phí ship</Typography>
        <FormControlLabel
          control={
            <Switch
              checked={shippingEnabled}
              onChange={(e) => setShippingEnabled(e.target.checked)}
              color="primary"
            />
          }
          label={
            shippingEnabled
              ? `+${(35000).toLocaleString("vi-VN")}₫`
              : "Miễn phí"
          }
        />
      </Box>

      <Divider sx={{ my: 1.5 }} />

      {/* Tổng cộng */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          mb: 2,
          flexWrap: "wrap",
        }}
      >
        <Typography variant="h6">Tổng cộng</Typography>
        <Typography variant="h5" color="primary" fontWeight="bold">
          {finalTotal.toLocaleString("vi-VN")}₫
        </Typography>
      </Box>

      {/* Nút thanh toán */}
      <Button
        variant="contained"
        fullWidth
        size="large"
        startIcon={<ReceiptIcon />}
        onClick={onCheckout}
        disabled={!canCheckout}
        sx={{
          py: 1.3,
          borderRadius: 2,
          fontWeight: "bold",
        }}
      >
        THANH TOÁN
      </Button>
    </Box>
  );
}
